<template>
  <PersonalizedPaymentSteps
    class="smaller-container-wrapper"
    :heading="$t('message.eCommerceV2.personalizedPayment.stepOne.heading')"
    :currentStep="1"
  >
    <p data-cy="stepMessage">{{ $t('message.eCommerceV2.personalizedPayment.stepOne.msg') }}</p>
  </PersonalizedPaymentSteps>
</template>

<script>
import PersonalizedPaymentSteps from '@/components/e-commerce-v2/layout/PersonalizedPaymentSteps.vue';

export default {
  name: 'StepOne',
  components: {
    PersonalizedPaymentSteps,
  },
};
</script>
